import React, { ReactElement } from 'react'
import ComissionDisclosure from 'views/cremation/components/CommissionDisclosure'

const ComissionDisclosureUpfront = (): ReactElement => (
  <ComissionDisclosure paymentType="upfront" />
)
export default ComissionDisclosureUpfront
